// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"928":"dc7b54b9b59cf011","8914":"d47e4f3ff15ec2c4","13678":"57cb0da95d0342cc","48846":"6438dbb375600f1b","53746":"e8dec7efcdc6dc08","64558":"3dd81c0e18a02d8d","85177":"4596091eaf60e5b8"}[chunkId] + ".css";
};